import {
    ApproveStatus,
    ApproverDetails,
    BesuApproveStatus,
    BesuClaimListApprover,
    BesuClaimListItem,
    BesuClaimListStatus,
    ClaimStatus,
    ClaimStatusWithNestedStatus,
} from "../types/claim";
import { BesuProjectParty } from "../types/project";
import { UserRole } from "../types/userCurrent";

import { hasClaimAction, hasNestedClaimAction } from "./claim";
import { isNodeDeveloper } from "./role";

export const claimListStatusToClaimStatus = (
    status: BesuClaimListStatus,
): ClaimStatus =>
    status === "DELETED" ? ClaimStatus.DISCARDED : status;


const approverListStatusToApproveStatus = (
    status?: BesuApproveStatus,
): ApproveStatus | undefined =>
    status === "DISCARDED" ? undefined : status;

const approverToApproverDetails = (
    approver: BesuClaimListApprover,
): ApproverDetails => ({
    ...approver,
    status: approverListStatusToApproveStatus(approver.status),
});

export const claimListItemToNestedStatus = (
    claim: BesuClaimListItem,
): ClaimStatusWithNestedStatus => ({
    claimStatus: claimListStatusToClaimStatus(claim.claimStatus),
    invoiceStatuses: claim.invoiceStatuses.map((invoice) => ({
        invoiceStatus: invoice.invoiceStatus,
        paymentInfo: invoice.paymentInfo
            ? {
                ...invoice.paymentInfo,
                paymentOrderApprovers: invoice.paymentInfo.paymentOrderApprovers.map(approverToApproverDetails),
            }
            : null,
    })),
});

export const isClaimVisibleForCurrentUser = (
    claim: BesuClaimListItem,
    currentUserAccountName?: string,
    mainContractors: BesuProjectParty[] = [],
): boolean =>
    isNodeDeveloper() ||
    currentUserAccountName === claim.contractorAccountName ||
    currentUserAccountName === claim.contractorDisplayName ||
    mainContractors.some((contractor) =>
        contractor.accountName === currentUserAccountName &&
        contractor.wallet?.toLowerCase() === claim.contractorWallet.toLowerCase(),
    );

const currentApproverStatus = (
    claim: BesuClaimListItem,
    currentUserEmail?: string,
): ApproveStatus | undefined => {
    const approver = claim.claimApprovers.find(
        (it) => it.details.email === currentUserEmail,
    );
    return approverListStatusToApproveStatus(approver?.status);
};

export const hasClaimListAction = (
    roles: UserRole[],
    claim: BesuClaimListItem,
    currentUserEmail?: string,
): boolean =>
    hasNestedClaimAction(
        roles,
        claimListItemToNestedStatus(claim),
        currentApproverStatus(claim, currentUserEmail),
        currentUserEmail,
    );

export const hasClaimListClaimAction = (
    roles: UserRole[],
    claim: BesuClaimListItem,
    currentUserEmail?: string,
): boolean =>
    hasClaimAction(
        roles,
        claimListStatusToClaimStatus(claim.claimStatus),
        claim.invoiceCount > 0,
        currentApproverStatus(claim, currentUserEmail),
    );